define.alias("ember-math-helpers/helpers/hypot", "calendar/helpers/hypot");